import { areDevToolsUnlocked } from '@stores/dev-tools';
import { LocalStorage } from '@stores/local-storage';
import { Modal } from '@ui/core/modal/Modal';
import { addNotification } from '@ui/core/notification/Notification.utils';
import { createElement } from 'preact';

const loadDevTools = () => import('./components/Dev');
let isOpen = false;

export namespace DevTools {
    // TODO: Separate loading and opening
    export function open(): void {
        if (!areDevToolsUnlocked.value)
            addNotification({ title: 'DevTools unlocked', content: 'Hi there Test user. DevTools are now unlocked.', type: 'success' });
        areDevToolsUnlocked.value = true;
        LocalStorage.set('devTools', 'true');
        loadDevTools().then((module) => {
            if (isOpen) return;
            isOpen = true;
            areDevToolsUnlocked.value = true;
            Modal.open({ children: createElement(module.Dev, {}), size: 'm', onClose: () => (isOpen = false) });
        });
    }
}
